define('common/dialog', ['jquery', 'log', 'common/util', 'jquery.blockUI'], ($, log) => {
    // log格式showLog、confirmLog、cancelLog;
    // {
    //     event:'事件名',
    //     expand: '参数';
    // }
    // 新增回调showBlock、beforeConfirm、afterConfirm、beforeCancel、afterCancel、onFinally
    function show(opt) {
        const defaultClass = 'rrc-diaglog';
        const defaultOpt = {
            title: '提示',
            baseZ: 50001,
            blockMsgClass: defaultClass,
            showClose: true,
            css: {
                minWidth: opt.width || '300px',
            },
            onBlock() {
                if (opt.showBlock) opt.showBlock(); // 弹窗展示的回调
                if (opt.showLog) { // 弹窗展示需要的埋点
                    log.push(['_trackEvent', opt.showLog.event, '', '', '', opt.showLog.expand]);
                }
                $(`.${defaultClass} .confirm`).off('click').on('click', () => {
                    if (opt.confirmLog) {   // 点击确定需要的埋点
                        log.push(['_trackEvent', opt.confirmLog.event, '', '', '', opt.confirmLog.expand]);
                    }
                    const cb = () => {
                        $.unblockUI();
                        if (opt.afterConfirm && opt.afterConfirm()) return; // 关闭确定弹窗后的回调
                    };
                    if (opt.beforeConfirm) {    // 点击确定关闭弹窗之前的回调
                        opt.beforeConfirm(() => {
                            cb();
                        });
                    } else {
                        cb();
                    }
                });
                $(`.${defaultClass} .cancel`).off('click').on('click', () => {
                    if (opt.cancelLog) {    // 点击取消需要的埋点
                        log.push(['_trackEvent', opt.cancelLog.event, '', '', '', opt.cancelLog.expand]);
                    }
                    const cb = () => {
                        $.unblockUI();
                        if (opt.afterCancel && opt.afterCancel()) return; // 点击取消关闭弹窗之后的回调
                    };
                    if (opt.beforeCancel) { // 点击去死袄关闭弹窗之前的回调
                        opt.beforeCancel(() => {
                            cb();
                        });
                    } else {
                        cb();
                    }
                });
            },
            onUnblock(w, opts) {
                $(`.${defaultClass} .confirm`).off('click');
                $(`.${defaultClass} .cancel`).off('click');
                opt.onFinally && opt.onFinally(opts); // eslint-disable-line
            }
        };
        const option = $.extend({}, defaultOpt, opt);
        if (opt.blockMsgClass) {
            option.blockMsgClass += ` ${defaultClass}`;
        }
        $.blockUI(option);
    }

    return {
        show
    };
});

